<template lang="pug">
v-card.rounded-lg.pa-6.mb-4(color="white" flat)
  .text-lg.font-semibold {{ title }}
  div(v-if="loading")
    v-skeleton-loader(type="list-item-three-line@2")
  div(v-else)
    v-card(flat)
      apexchart(v-if="data.values" type="bar" :options="chartOptions" :series="series")
      v-overlay.primary--text.text-center(v-if="isEmptyChartData" absolute color="white" opacity="0.9" z-index="2")
        v-icon.mb-2(color="primary" size=20) $yzi-bar-chart-10
        .h8.mb-1 No data available
        .text-sm There’s no data available yet for this chart
</template>

<script>
export default {
  name: 'HorizontalBarCard',
  props: {
    title: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: true
    },
    overview: {
      type: Object,
      default: null
    },
    data: {
      type: Object,
      default: null
    },
    type: {
      type: String
    },
    datatype: {
      type: String
    }
  },
  data: () => ({}),
  computed: {
    series () {
      const data = this.data?.values ?? []
      return [{ 
        data,
        name: '',
      }]
    },
    chartOptions () {
      let data = {
        colors: this.colors,
        chart: {
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            borderRadiusApplication: 'end',
            horizontal: true,
            dataLabels: {
              position: 'top'
            },
          }
        },
        dataLabels: {
          enabled: true,
          textAnchor: 'end',
          style: {
            colors: ['#fff']
          },
          formatter: (value, opt) => {
            let text = ''
            if (this.data.percentage[opt.dataPointIndex]) {
              text += `${this.data.percentage[opt.dataPointIndex].toFixed(1)}%`
            }
            return text
          },
          offsetX: 60,
          background: {
            enabled: true,
            foreColor: '#333'
          }
        },
        legend: {
          show: false
        },
        labels: this.data?.labels ?? [],
      }
      if (this.datatype === 'currency') {
        data.xaxis = {
          labels: {
            formatter: (value) => {
              return value / this.$currency.multiplier
            }
          },
        }
        data.yaxis = {
          labels: {
            style: {
              fontFamily: '$body-font-family',
              fontSize: '12px'
            }
          }
        }
        data.tooltip = {
          y: {
            formatter: (value) => {
              return this.$options.filters.displayPriceNoCent(value, this.$currency)
            }
          },
          style: {
            fontFamily: '$chart-font-family',
            fontSize: '16px',
          },
          marker: {
            show: false
          }
        }
      }
      return data
    },
    isEmptyChartData () {
      return this.series[0].data.every(item => item === 0)
    },
    colors () {
      switch (this.type) {
        case 'patients':
          return this.series.length === 2 ? ['#5856d6', '#cfc4f5'] : ['#5856d6', '#8579e1', '#ac9eeb', '#cfc4f5', '#f0ebff']
        default:
          return ['#FEC84D']
      }
    },
  }
}
</script>